import { Component, ViewChild, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription, Observable } from 'rxjs';
import { JsonEditorOptions, JsonEditorComponent, NgJsonEditorModule } from 'ang-jsoneditor';
import { tap } from 'rxjs/operators';
import { TileComponent } from 'shared';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-igrid-installation-module-configuration-form',
    templateUrl: './igrid-installation-module-configuration-form.component.html',
    styleUrls: ['./igrid-installation-module-configuration-form.component.scss'],
    imports: [
    TileComponent,
    FormsModule,
    ReactiveFormsModule,
    NgJsonEditorModule,
    AsyncPipe,
    TranslateModule
],
})
export class IGridInstallationModuleConfigurationFormComponent implements OnInit, OnDestroy {
  @Input() public modules: Observable<any[]>;
  public form: UntypedFormGroup;
  @ViewChild(JsonEditorComponent, { static: false })
  editor: JsonEditorComponent;

  private readonly subscriptions = new Subscription();

  constructor(private readonly formBuilder: UntypedFormBuilder) {
    this.form = this.formBuilder.group({});
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.modules
        .pipe(
          tap((modules) => {
            return modules?.length && this.addFormControlForModules(modules);
          }),
        )
        .subscribe(),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  makeOptions = (): JsonEditorOptions => {
    const opts = new JsonEditorOptions();
    opts.modes = ['tree'];
    return opts;
  };

  addFormControlForModules(modules: any[]) {
    for (const module of modules) {
      this.form.addControl(module.name, new UntypedFormControl());
      this.form.controls[module.name]?.setValue(module);
    }
  }
}
